export default "__VITE_ASSET__fa3ad0b0__"